import React from 'react'
import './ListSearch.scss'
import moment from 'moment'

const ListSearch = ({ data, buttonTitle }) => {
  return (
    <>
      {data?.map((item) => {
        const detailPage = (param, id) => {
          switch (param) {
            case 'Artikel':
              return `/inspiration/artikel/${id}`
            case 'Agenda':
              return `/agenda`
            case 'HubunganInvestor':
              return `/investor`
            case 'InformasiSaham':
              return `/share-holders`
            case 'InformasiTerbaru':
              return `/info-terbaru`
            case 'InsipirasiTerkini':
              return `/inspiration/artikel/${id}`
            case 'JaringanATM':
              return `/network/atm`
            case 'JaringanKantor':
              return `/network/kantor`
            case 'Laporan':
              return `/investor`
            case 'LayananNasabah':
              return `/support-center`
            case 'LayananTerbaik':
              return `/bisnis-service/${id}`
            case 'Obligasi':
              return `/obligation`
            case 'PencatatanSaham':
              return `/corporate-action`
            case 'Promotion':
              return `/promotion/detail/${id}`
            case 'SBDK':
              return `/sbdk`
            case 'SolusiBisnis':
              return `/business-solution/detail/${id}`
            case 'SolusiKeseharianCreditCard':
              return `/credit-card/${id}`
            case 'SolusiKeseharianDebitCardCoBranding':
              return `/debit-card/${id}`
            case 'SolusiKeseharianPrioritas':
              return `/bukopin-priority`
            case 'SolusiMasaDepanKoreanLink':
              return `/korean-link/${id}`
            case 'SolusiMasaDepanPinjaman':
              return `/loan/${id}`
            case 'SolusiMasaDepanSimpanan':
              return `/savings/${id}`
            case 'SolusiMasaDepanWealth':
              return `/wealth-management/${id}`
            case 'StrukturOrganisasi':
              return `/structure-corporate/struktur-organisasi`
            case 'TemukanKami':
              return `/network/atm`
            case 'TentangKamiBankKoresponden':
              return `/profile/correspondent-bank`
            case 'karir':
              return `/career-work`
            case 'TentangKami-riwayat':
              return `/profile/history`
            case 'TentangKami-visiMisi':
              return `/profile/vision-mission`
            case 'TentangKami-segmenBisnis':
              return `/profile/business-segment`
            case 'TentangKami-anakPerusahaan':
              return `/profile/subsidiary`
            case 'TentangKami-budayaPerusahaan':
              return `/profile/corporate-culture`
            case 'TentangKami-penghargaan':
              return `/profile/award`
            case 'TentangKami-bankKoresponden':
              return `/profile/correspondent-bank`
            case 'TentangKami-lembagaProfesi':
              return `/profile/institute-bank`
            case 'TentangKami-hubungiKami':
              return `/profile/contact-us`
            case 'TataKelolaPerusahaan-piagam':
              return `/corporate-governance/piagam`
            case 'TataKelolaPerusahaan-pedoman':
              return `/corporate-governance/guidelines`
            case 'TataKelolaPerusahaan-laporanTataKelola':
              return `/corporate-governance/report`
            case 'TataKelolaPerusahaan-kodeEtik':
              return `/corporate-governance/code-of-ethics`
            case 'TataKelolaPerusahaan-whistleblowingSystem':
              return `/corporate-governance/whistleblowing-system`
            case 'StrukturManajemen-dewanKomisaris':
              return `/structure-corporate/komisaris`
            case 'StrukturManajemen-dewanDireksi':
              return `/structure-corporate/direksi`
            case 'StrukturManajemen-komite':
              return `/structure-corporate/komite`
            case 'StrukturManajemen-sekretarisPerusahaan':
              return `/structure-corporate/sekretarisperusahaan`
            case 'StrukturManajemen-strukturOrganisasi':
              return `/structure-corporate/struktur-organisasi`
            case 'TanggungJawabSosial-kebijakanTanggungJawab':
              return `/csr-policy`
            case 'TanggungJawabSosial-pelaksanaanTanggungJawab':
              return `/csr-activity`
            case 'TataKelolaPerusahaan-TentangTataKelolaPerusahaan':
              return `/corporate-governance/about`
            default:
              return
          }
        }

        return (
          <div class="list-item-search" key={item.id}>
            <div className="content-wrapper">
              <span className="date">
                {moment(item.date, 'DD-MM-YYYY HH:mm:ss').format('DD MMM YYYY')}{' '}
                | {item.object_title}
              </span>
              <h5 className="title-list">{item.title}</h5>
              <div
                className="body"
                dangerouslySetInnerHTML={{
                  __html: item.desc,
                }}
              ></div>
            </div>
            <a href={detailPage(item.object, item.id)}>
              <button className="btn btn-list">{buttonTitle}</button>
            </a>
          </div>
        )
      })}
    </>
  )
}

export default ListSearch
